const CLIENT_ID = process.env.REACT_APP_OKTA_OAUTH2_CLIENT_ID || '';
const ISSUER = process.env.REACT_APP_OKTA_OAUTH2_ISSUER || '';
const OKTA_TESTING_DISABLEHTTPSCHECK = process.env.REACT_APP_OKTA_TESTING_DISABLEHTTPSCHECK || false;
const OKTA_OAUTH2_CLIENT_SECRET = process.env.REACT_APP_OKTA_OAUTH2_CLIENT_SECRET || '';
const BASENAME = process.env.PUBLIC_URL || '';
const REDIRECT_URI = `${window.location.origin}${BASENAME}/callback`;

export default {
  oidc: {
    clientId: CLIENT_ID,
    clientSecret: OKTA_OAUTH2_CLIENT_SECRET,
    issuer: ISSUER,
    redirectUri: REDIRECT_URI,
    scopes: ['openid', 'offline_access'],
    pkce: false,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
  }
};